import { globalGetService, globalPostService, } from '../utils/globalApiServices';
import { setBanks, setAsset, setEvent, setConstantTypes, setLessee, setLessor, setOwner, setPermission, setLoading, setLeaseBasicDetails, setCurrencies, setAssembly, setRevisonHistory, setStorage, setSummryList, setUserLessorList } from './actions';
import { checkApiStatus } from '../utils';

let isFetchingPermissions = false;
export const getPermissionsAc = (props = {}, payload = {}) => {
  return (dispatch) => {
    if (isFetchingPermissions) return;
    isFetchingPermissions = true;
    dispatch(setLoading(true));
    globalPostService(`permissions/`, payload)
      .then(response => {
        if (checkApiStatus(response)) {
          isFetchingPermissions = false;
          dispatch(setLoading(false));
          dispatch(setPermission(response.data.data))
        }
      })
  }
}

export const getLessorAc = (query = {}) => {
  return (dispatch) => {
    globalGetService(`api/dropdown/lessor/`, query)
      .then(response => {
        if (checkApiStatus(response)) {
          dispatch(setLessor(response.data.data))
        }
      })
  }
}

export const getLesseeAc = (query = {}) => {
  return (dispatch) => {
    globalGetService(`api/dropdown/lessee/`, query)
      .then(response => {
        if (checkApiStatus(response)) {
          dispatch(setLessee(response.data.data))
        }
      })
  }
}

export const getBanksAc = (query = {}) => {
  return (dispatch) => {
    const { lessor_id, show_all } = query;
    const params = new URLSearchParams();
    if (lessor_id) params.append('lessor_id', lessor_id);
    if (show_all) params.append('show_all', show_all);
    const queryString = params.toString();
    const url = `api/dropdown/banks/${queryString ? `?${queryString}` : ''}`;

    return globalGetService(url)
      .then(response => {
        if (checkApiStatus(response)) {
          const bankRecords = response?.data?.data || [];
          dispatch(setBanks(bankRecords));
          return bankRecords;
        }
      });
  };
};

export const getCurrencyAc = (query = {}) => {
  return (dispatch) => {
    globalGetService(`/console/currency/`, query)
      .then(response => {
        if (checkApiStatus(response)) {
          dispatch(setCurrencies(response.data.data))
        }
      })
  }
}

export const getAssetListApi = (query = {}) => {
  return (dispatch) => {
    const { setIsDropDownLoading, ...urlParams } = query;
    const params = {
      include_on_wing: true,
      ...urlParams,
    };

    const queryString = Object.keys(params).length
      ? '?' + new URLSearchParams(params).toString()
      : '';
      
    globalGetService(`/api/dropdown/asset/${queryString}`)
      .then((response) => {
        dispatch(setAsset(response?.data?.data));
      })
      .catch(() => {})
      .finally(() => {
        setIsDropDownLoading?.((prev) => ({ ...prev, assetList: false, }));
      });
  };
};

export const getConstantTypesApi = (payload, query = {}) => {
  return (dispatch) => {
    globalPostService(`lease/constants/get_by_constant_types`, payload).then((response) => {
      if (checkApiStatus(response)) {
        dispatch(setConstantTypes(response?.data?.data));
        query?.setIsDropDownLoading?.(prev => ({ ...prev, constantTypes: false }));
      }
    });
  };
};

export const getLesseeApi = (query = {}) => {
  return (dispatch) => {
    globalGetService(`api/dropdown/lessee`, query).then((response) => {
      dispatch(setLessee(response?.data?.data));
      query?.setIsDropDownLoading?.(prev => ({ ...prev, lessee: false }));
    });
  };
};

export const getOwnerListApi = (query = {}) => {
  return (dispatch) => {
    globalGetService(`api/dropdown/owner`, query).then((response) => {
      dispatch(setOwner(response?.data?.data));
      query?.setIsDropDownLoading?.(prev => ({ ...prev, owner: false }));
    });
  };
};

export const getOwnerLessorApi = (query = {}) => {
  return (dispatch) => {
    globalGetService(`api/dropdown/lessor`, query).then((response) => {
      dispatch(setLessor(response?.data?.data));
      query?.setIsDropDownLoading?.(prev => ({ ...prev, lessor: false }));
    });
  };
};

export const getEventListApi = (params = {}, query) => {
  return (dispatch) => {
    const queryString = new URLSearchParams(query).toString();
    globalGetService(`lease/${params?.leaseSlug}/reserve_accounts/${queryString ? `?${queryString}` : ""}`, params).then((response) => {
      dispatch(setEvent(response?.data?.data));
      params?.setEventLoading(false)
    });
  };
};

export const fetchLeaseBasicDetails = (query = {}) => {
  return (dispatch) => {
    const { slug, setLoading } = query
    const queryString = new URLSearchParams({ slug }).toString();
    globalGetService(`/lease/info${queryString ? `?${queryString}` : ""}`)
      .then((response) => {
        if (checkApiStatus(response)) {
          dispatch(setLeaseBasicDetails(response?.data?.data));
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };
};

export const getAssemblysApi = (params, query = {}) => {
  return (dispatch) => {
    globalGetService(`console/${params?.leaseSlug}/major-assembly`, query).then((response) => {
      dispatch(setAssembly(response?.data.data));
      query?.setIsDropDownLoading?.(prev => ({ ...prev, assembly: false }));
    });
  };
};

export const getRevisionHistory = (module_name, module_list_slug, section_type, query) => {
  return (dispatch) => {
    query?.setLoading?.(true);
    const queryString = new URLSearchParams(section_type).toString();
    if (query?.section_type) {
      globalGetService(`/audit-logs/${module_name}/${module_list_slug}${queryString ? `?${queryString}` : ""}`, query).then((response) => {
        dispatch(setRevisonHistory(response?.data.data));
        query?.setLoading?.((prev) => !prev);
      });
    } else {
      globalGetService(`/audit-logs/${module_name}/${module_list_slug}${queryString ? `?${queryString}` : ""}`).then((response) => {
        dispatch(setRevisonHistory(response?.data?.data));
      }).finally(() => query?.setLoading?.(false));
    }
  };
};

export const getStorage = (query) => {
  return (dispatch) => {
    query?.setIsDropDownLoading?.(prev => ({ ...prev, storage: true }));
    globalPostService(`/remaining-storage`, query).then((response) => {
      dispatch(setStorage(response?.data.data));
      query?.setIsDropDownLoading?.(prev => ({ ...prev, storage: false }));
    });
  };
};

export const getModuleWiseRevisionHistory = (leaseSlug, module_name, setLoading, query, section_type) => {
  return (dispatch) => {
    if (!leaseSlug) {
      query?.setLoading(true);
      globalGetService(`/audit-logs/history/${module_name}`)
        .then((response) => {
          dispatch(setRevisonHistory(response?.data?.data));
        })
        .finally(() => {
          query?.setLoading(false);
        });
    } else {
      query?.setLoading(true);
      globalGetService(`/audit-logs/lease/${leaseSlug}/history/${module_name}`)
        .then((response) => {
          dispatch(setRevisonHistory(response?.data?.data));
        })
        .finally(() => {
          query?.setLoading(false);
        });
    };
  }

};

export const getDeliveryModuleRevisionHistory = (module_name, query = {}, leaseSlug) => {
  return (dispatch) => {
    query.setLoading?.(true);
    const { setLoading, ...urlParams } = query; const queryString = Object.keys(urlParams).length ? '?' + new URLSearchParams(urlParams).toString() : '';
    globalGetService(`/audit-logs/lease/${leaseSlug}/history/${module_name}${queryString}`)
      .then((response) => {
        dispatch(setRevisonHistory(response?.data?.data));
      })
      .finally(() => {
        query?.setLoading?.(false);
      });
  };
};

export const getDeliveryEventRecordRevisionHistory = (module_name, query = {}, leaseSlug) => {
  return (dispatch) => {
    query.setLoading?.(true);
    const { setLoading, ...urlParams } = query; const queryString = Object.keys(urlParams).length ? '?' + new URLSearchParams(urlParams).toString() : '';
    globalGetService(`audit-logs/delivery_redelivery_maintenance_event/${leaseSlug}`)
      .then((response) => {
        dispatch(setRevisonHistory(response?.data?.data));
      })
      .finally(() => {
        query?.setLoading?.(false);
      });
  };
};
export const getDeliveryAssemblyRecordRevisionHistory = (module_name, query = {}, leaseSlug) => {
  return (dispatch) => {
    query.setLoading?.(true);
    const { setLoading, ...urlParams } = query; const queryString = Object.keys(urlParams).length ? '?' + new URLSearchParams(urlParams).toString() : '';
    globalGetService(`audit-logs/delivery_redelivery_assembly/${leaseSlug}`)
      .then((response) => {
        dispatch(setRevisonHistory(response?.data?.data));
      })
      .finally(() => {
        query?.setLoading?.(false);
      });
  };
};

export const getNonLeaseModuleWiseRevisionHistory = (module_name, setLoading, query) => {
  return (dispatch) => {
    if (query?.asset_type) {
      const queryString = new URLSearchParams(query).toString();
      const url = `/audit-logs/global/history/${module_name}${queryString ? `?${queryString}` : ""}`;
      globalGetService(url)
        .then((response) => {
          dispatch(setRevisonHistory(response?.data?.data));
        })
        .finally(() => {
          if (typeof setLoading === "function") setLoading(false);
        });
    } else {
      const url = `/audit-logs/global/history/${module_name}`;
      globalGetService(url)
        .then((response) => {
          dispatch(setRevisonHistory(response?.data?.data));
        })
        .finally(() => {
          if (typeof setLoading === "function") setLoading(false);
        });
    }
  };
};

export const getLeaseSummryExport = (query = {}, setLoading) => {
  return (dispatch) => {
    setLoading(true);
    globalGetService(`lease-summary/templates`, query)
      .then((response) => {
        if (checkApiStatus(response)) {
          dispatch(setSummryList(response.data.data));
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
};

export const getUserLessorListApi = (query = {}) => {
  return (dispatch) => {
    globalGetService(`lessor-drop-down/`, query).then((response) => {
      dispatch(setUserLessorList(response?.data?.data));
      query?.setIsDropDownLoading?.(prev => ({ ...prev, userLessorList: false }));
    });
  };
};